import type { ManagerAssignment, CreateAssignmentInput } from '@grosync/common';
import { apiGet, apiPost, apiDelete } from './client';

/** 담당자→사용자 배정 목록 (전체). */
export function fetchAssignments(): Promise<ManagerAssignment[]> {
  return apiGet<ManagerAssignment[]>('/api/assignments');
}

/** 사용자 1명을 담당자에 연결(user_id 기준 upsert). */
export function createAssignment(body: CreateAssignmentInput): Promise<ManagerAssignment> {
  return apiPost<ManagerAssignment>('/api/assignments', body);
}

/** 사용자의 담당자 연결 해제. */
export function deleteAssignment(userId: string): Promise<{ deleted: boolean }> {
  return apiDelete<{ deleted: boolean }>(`/api/assignments/${userId}`);
}
